import { render, staticRenderFns } from "./Participaciones.vue?vue&type=template&id=b72ce7d2&scoped=true&"
import script from "./Participaciones.vue?vue&type=script&lang=js&"
export * from "./Participaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ce7d2",
  null
  
)

export default component.exports